import { AddToast } from 'react-toast-notifications';
import { apolloClient } from '@lib/apollo';
import {
  APPROVE_DENY_RESULT_SHEET,
  approveDenyResultSheetMutation,
  approveDenyResultSheetMutationVariables,
} from '@app-types/graphql-types';
import Router from 'next/router';
import { Dispatch, SetStateAction } from 'react';
import { logError } from '@lib/logger';

interface ApproveDenyResultSheetArgs {
  resultSheetId: string;
  addToast: AddToast;
  academicHeadRemark?: string;
  isApproved;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
}

export const approveDenyResultSheet = async ({
  resultSheetId,
  addToast,
  academicHeadRemark,
  isApproved,
  setIsLoading,
}: ApproveDenyResultSheetArgs): Promise<void> => {
  setIsLoading(true);

  try {
    await apolloClient.mutate<approveDenyResultSheetMutation, approveDenyResultSheetMutationVariables>({
      mutation: APPROVE_DENY_RESULT_SHEET,
      variables: {
        where: {
          id: resultSheetId,
        },
        data: {
          isApproved,
          academicHeadRemark,
        },
      },
    });

    setIsLoading(false);

    addToast(`Result sheet ${isApproved ? 'successfully approved' : 'rejected'}.`, {
      appearance: isApproved ? 'success' : 'warning',
      autoDismiss: true,
    });

    Router.push('/result-sheets').then();
  } catch (error) {
    setIsLoading(false);

    addToast('Error. Something went wrong. Please try again.', {
      appearance: 'error',
      autoDismiss: true,
    });

    logError(error);
  }
};
